export const gatherIds = list => {
    const idsArray = list
        .filter(item => item.isSelected)
        .map(item => item.portfolioId);
    
    return idsArray;
}